import React from 'react';
import './css/Sidebar.css';
import { makeRequest } from '../Helpers';

export default function Sidebar(props) {
  const handleReload = async () => {
    props.loading(true);

    const jokes = [];

    let i = 0;

    while (i <= 10) {
      const request = makeRequest('https://icanhazdadjoke.com/');
      await request.then(data => {
        jokes.push({ ...data, score: 0 });
      });
      i++;
    }

    localStorage.setItem('jokes', JSON.stringify(jokes));
    props.reloadJokes(jokes);
    props.loading(false);
  };

  return (
    <div className="Sidebar">
      <h1 className="Sidebar-title">
        Dad <span>Jokes</span>
      </h1>

      <div className="Sidebar-img-container">
        <img
          className="Sidebar-img"
          src="https://assets.dryicons.com/uploads/icon/svg/8927/0eb14c71-38f2-433a-bfc8-23d9c99b3647.svg"
          alt="Amix"
        />
      </div>

      <button className="Sidebar-button" onClick={handleReload}>
        New Jokes
      </button>
    </div>
  );
}
